import axios from 'axios';
import { message } from 'antd';
import RoutesIndexes from 'modules/authModule/enums/RoutesIndexes';
import apiUrl from '../../../helpers/apiUrl';

export async function loginUserRequest(credentials: any): Promise<null | {
  accessToken: string | undefined;
  refreshToken: string | undefined;
  userId: string | undefined;
}> {
  return axios
    .post(`${apiUrl()}backoffice/auth/login`, credentials)
    .then((response) => {
      if (response.data.code === RoutesIndexes.WRONG_USERNAME_OR_PASSWORD) {
        message.error(response.data.message);
        return null;
      }
      if (response?.data) {
        return response.data;
      }
      return null;
    });
}

export async function changePasswordRequest(credentials: any): Promise<null | {
  accessToken: string | undefined;
  refreshToken: string | undefined;
  userId: string | undefined;
  code: number;
}> {
  return axios
    .post(`${apiUrl()}backoffice/auth/change-password`, credentials)
    .then((response) => {
      if (response.data.code === RoutesIndexes.WRONG_USERNAME_OR_PASSWORD) {
        message.error(response.data.message);
        return null;
      }
      if (response?.data) {
        return response.data;
      }
      return null;
    });
}

export async function refreshTokenRequest(): Promise<{
  data: { refreshToken: string; accessToken: string; loginRequired?: boolean };
}> {
  const token = localStorage.getItem('token');
  return axios.post(`${apiUrl()}backoffice/auth/refresh`, {
    refreshToken: JSON.parse(<string>token)?.refreshToken,
    userId: JSON.parse(<string>token)?.userId,
  });
}

export async function validateTokenRequest(): Promise<{
  data: {
    refreshToken: string;
    accessToken: string;
    changePassword: boolean;
    userId: string;
  };
} | null> {
  const token = localStorage.getItem('token');
  if (token) {
    return axios.post(
      `${apiUrl()}backoffice/auth/check-authentication`,
      {
        refreshToken: JSON.parse(<string>token).refreshToken,
        user: JSON.parse(<string>token).userId,
      },
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(<string>token)?.accessToken}`,
        },
      }
    );
  }
  return null;
}

export async function logoutUserRequest(): Promise<null | boolean> {
  return axios
    .post(`${apiUrl()}backoffice/auth/logout`, {
      token: localStorage.getItem('token'),
    })
    .then((response) => {
      // @ts-ignore
      if (response.data.code === RoutesIndexes.WRONG_USERNAME_OR_PASSWORD) {
        // @ts-ignore
        message.error(response.data.message);
        return null;
      }
      return true;
    });
}
